<template>
  <DropdownMenu
    v-if="!isEdit && customDashboardState.userCanManageCustomDashboard"
    :items="DROPDOWN_MENU_ACTIONS"
    :offset="[0, 0]"
    :type="DROPDOWN_MENU_TYPES.DEFAULT_NEXT"
    class="tma-Actions"
    data-export-ignore
    preferred-position="bottom-end"
    @item-click="onMenuActionsClick"
  >
    <template #activator>
      <AppButton data-export-ignore icon="more-next" size="sm" type="subtle" />
    </template>
  </DropdownMenu>
</template>

<script setup>
import { inject } from 'vue'

import { ACTIONS_KEYS } from '@/utils/actions-keys'
import { DROPDOWN_MENU_TYPES } from '@/utils/components-configurations/dropdown-menu'
import { MENU_ITEMS_GROUPS } from '@/utils/dropdown-menu'
import { customDashboardStateInjectionKey } from '@/utils/injection-keys'

import AppButton from '@/components/ui/AppButton/AppButton'
import DropdownMenu from '@/components/ui/DropdownMenu/DropdownMenu'

defineOptions({
  name: 'TextModuleActions'
})

const props = defineProps({
  isEdit: {
    type: Boolean
  }
})

const emit = defineEmits({
  'update:is-edit': null,
  'show-remove': null
})

const customDashboardState = inject(customDashboardStateInjectionKey)

const { EDITING, REMOVING } = MENU_ITEMS_GROUPS
const { REMOVE, EDIT } = ACTIONS_KEYS

const DROPDOWN_MENU_ACTIONS = [
  {
    name: EDIT,
    title: 'action.edit',
    icon: 'edit-next',
    group: EDITING
  },
  {
    name: REMOVE,
    title: 'action.delete',
    icon: 'delete-next',
    color: 'var(--grade-low-color-next)',
    group: REMOVING
  }
]

const onEdit = () => {
  emit('update:is-edit', true)
}

const onRemove = () => {
  emit('show-remove', props.formModel)
}
const onMenuActionsClick = name => {
  if (name === EDIT) {
    onEdit()
  } else if (name === REMOVE) {
    onRemove()
  }
}
</script>

<style lang="scss" scoped></style>
